import { shareLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsShareLink";
import { css } from "styled-components";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";

Object.assign(shareLinkStyles, {
    wrapper: {
        css: css`
            margin-top: 0px;
            text-align: right;
            > button {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 44px;
                        `,
                        css`
                            width: 44px;
                        `,
                        null,
                        null,
                        null,
                    ])}
                svg {
                    stroke: #1e75ba;
                    width: 22px;
                    height: 22px;
                }
            }
        `,
    },
});
